module.exports = __webpack_public_path__ + "static/media/hoursBillable.e0d86c53.svg";